import malattieRare from '../assets/images/malattie-rare.png'
import pdta from '../assets/images/pdta-questionario.png'
import cefalee from '../assets/images/cefalee.png'

export const MIME_TYPE = {
  PDF: 'application/pdf',
  PNG: 'image/png',    
}

export const API_SERVICES = {
  MR:      { CODICE: "MR",   NOME: "MALATTIE RARE", IMAGE: malattieRare, HOME_ROUTE: '/malattie-rare/questionari', ROOT: '/malattie-rare' },
  PDTA:    { CODICE: "PDTA", NOME: "PDTA",          IMAGE: pdta,         HOME_ROUTE: '/pdta/questionari',          ROOT: '/pdta' } ,
  CEF:     { CODICE: "CEF",  NOME: "CEFALEE",       IMAGE: cefalee,      HOME_ROUTE: '/cefalee',                   ROOT: '/cefalee' } ,
}

export const TIPI_UTENTI_WEB = {
  MMG: 1,
  SPECIALISTA: 2
}

export { default as NotFound } from './NotFound'
export { default as Home } from './Home'

export { 
  PDTAHome, 
  PDTACategoria,
  PDTAScheda,
  PDTASubcategoria,
  PDTARisultato  
} from './pdta'

export { 
  MRHome,
  MRCategoria,
  MRScheda,
  MRSubcategoria,
  MRRisultato,
  MRCerca
} from './malattieRare'
